import { ShieldCheck } from "lucide-react";

import { useEffect } from "react";

import { useTranslation } from "react-i18next";

import { useNavigate } from "react-router-dom";

import { Button } from "@/components/ui/button";

import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";

import { GridPattern } from "@/components/ui/grid-pattern";

import { useAuth } from "../hooks/useAuth";

const Recommend2FAPage = () => {
  const navigate = useNavigate();

  const { t } = useTranslation("common");

  const { isAuthenticated, isLoading, session } = useAuth();

  useEffect(() => {
    if (isLoading) return;

    if (!isAuthenticated) {
      navigate("/login", { replace: true });

      return;
    }

    if (session.user?.twoFactorEnabled) {
      navigate("/integrations", { replace: true });
    }
  }, [isAuthenticated, isLoading, session.user, navigate]);

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <svg
          className="h-8 w-8 animate-spin text-primary"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          />
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          />
        </svg>
      </div>
    );
  }

  return (
    <div className="relative min-h-screen flex items-center justify-center px-4 overflow-hidden bg-background">
      <GridPattern
        width={40}
        height={40}
        className="[mask-image:radial-gradient(600px_circle_at_center,white,transparent)] [stroke:var(--primary)] [stroke-opacity:0.2]"
      />

      <Card className="relative z-10 w-full max-w-md">
        <CardHeader className="text-center">
          <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-primary/10 mb-4">
            <ShieldCheck className="h-7 w-7 text-primary" />
          </div>
          <CardTitle className="text-2xl">
            {t("RECOMMEND_2FA.title", "Secure your account")}
          </CardTitle>
          <CardDescription>
            {t(
              "RECOMMEND_2FA.subtitle",

              "Two-factor authentication adds an extra layer of security",
            )}
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-sm text-muted-foreground text-center">
            {t(
              "RECOMMEND_2FA.description",

              "We recommend enabling two-factor authentication to protect your admin account. You can set it up now or do it later from your profile settings.",
            )}
          </p>
          <Button className="w-full" onClick={() => navigate("/profile")}>
            {t("RECOMMEND_2FA.setupNow", "Set up now")}
          </Button>
          <Button
            variant="ghost"
            className="w-full"
            onClick={() => navigate("/integrations")}
          >
            {t("RECOMMEND_2FA.maybeLater", "Maybe later")}
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};

export default Recommend2FAPage;
